import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "as", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_ITEM_CLASS_NAME } from './ContinuousScrollItem.constants';
import { classNames } from '../../../../../../utils/classname';
import { createComponent } from '../../../../../foundation/services/components';
import { ChildrenPropType, ComponentPropType } from '../../../../../foundation/types/component';
var propTypes = {
  children: ChildrenPropType.isRequired,
  as: ComponentPropType,
  className: PropTypes.string
};
var defaultProps = {
  as: 'div',
  className: ''
};
export default function ContinuousScrollItem(_ref) {
  var _classNames;
  var children = _ref.children,
    as = _ref.as,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_ITEM_CLASS_NAME, true), _defineProperty(_classNames, className, true), _classNames));
  return createComponent(as, _objectSpread(_objectSpread({}, rest), {}, {
    children: children,
    className: finalClassName
  }));
}
ContinuousScrollItem.propTypes = propTypes;
ContinuousScrollItem.defaultProps = defaultProps;